import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    fontSize: theme.typography.$fzH2,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
  },
  description: {
    fontSize: theme.typography.$fzH4,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.67',
    letterSpacing: 'normal',
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH6,
      '& br': {
        display: 'none',
      },
    },
  },
  mb40: {
    marginBottom: '40px',
  },
  blockTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '40px',
  },
  ml20: {
    marginLeft: '20px',
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    marginRight: '20px',
    '@media (max-width: 767px)': {
      width: '80px',
    },
    ' & img': {
      width: '100%',
      height: 'auto',
    },
  },
}), 'content-page');
const ContentPage = ({ srcImage, title, content }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.blockTitle}>
        {srcImage && <div className={classes.image}><img src={srcImage} alt="#" /></div>}
        <div className={classes.title}>{title}</div>
      </div>
      <div className={classes.content}>{content}</div>
    </div>
  );
};

ContentPage.defaultProps = {
  srcImage: '',
  title: '',
};

ContentPage.propTypes = {
  srcImage: PropTypes.string,
  title: PropTypes.string,
};

export default ContentPage;